export default __webpack_public_path__ + "static/media/Games - X.07d99d72.png";